var SkapaFontSizeEnum;
(function (SkapaFontSizeEnum) {
    SkapaFontSizeEnum[SkapaFontSizeEnum["fontSize50"] = 12] = "fontSize50";
    SkapaFontSizeEnum[SkapaFontSizeEnum["fontSize75"] = 14] = "fontSize75";
    SkapaFontSizeEnum[SkapaFontSizeEnum["fontSize100"] = 16] = "fontSize100";
    SkapaFontSizeEnum[SkapaFontSizeEnum["fontSize200"] = 18] = "fontSize200";
    SkapaFontSizeEnum[SkapaFontSizeEnum["fontSize300"] = 20] = "fontSize300";
    SkapaFontSizeEnum[SkapaFontSizeEnum["fontSize400"] = 22] = "fontSize400";
    SkapaFontSizeEnum[SkapaFontSizeEnum["fontSize500"] = 25] = "fontSize500";
    SkapaFontSizeEnum[SkapaFontSizeEnum["fontSize600"] = 28] = "fontSize600";
    SkapaFontSizeEnum[SkapaFontSizeEnum["fontSize700"] = 32] = "fontSize700";
    SkapaFontSizeEnum[SkapaFontSizeEnum["fontSize800"] = 36] = "fontSize800";
    SkapaFontSizeEnum[SkapaFontSizeEnum["fontSize1000"] = 45] = "fontSize1000";
    SkapaFontSizeEnum[SkapaFontSizeEnum["fontSize1100"] = 50] = "fontSize1100";
})(SkapaFontSizeEnum || (SkapaFontSizeEnum = {}));
export default SkapaFontSizeEnum;
//# sourceMappingURL=SkapaFontSizeEnum.js.map